var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_91",
  "data-name": "Group 91",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_37_Copy_28",
  "data-name": "Rectangle 37 Copy 28",
  width: 16,
  height: 16,
  transform: "translate(0 0)",
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "exception",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.891,0H1.125A1.126,1.126,0,0,0,0,1.125v11.75A1.126,1.126,0,0,0,1.125,14H5.453a.563.563,0,0,0,0-1.125H1.125V1.125H12.891v11.75H11.578a.563.563,0,0,0,0,1.125h1.313a1.126,1.126,0,0,0,1.125-1.125V1.125A1.126,1.126,0,0,0,12.891,0Z",
  fill: "#afb6c0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M0,.563A.563.563,0,1,0,.281.075.563.563,0,0,0,0,.563Z",
  transform: "translate(9.016 12.875)",
  fill: "#afb6c0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-3",
  "data-name": "Shape",
  d: "M7.562,9A.563.563,0,0,1,7,8.437V2.563a.563.563,0,1,1,1.125,0V8.437A.563.563,0,0,1,7.562,9ZM3.437,7.125H.562A.563.563,0,0,1,.562,6H3.437a.563.563,0,1,1,0,1.125Zm0-3H.562A.563.563,0,0,1,.562,3H3.437a.563.563,0,1,1,0,1.125Zm2-3H.562A.563.563,0,0,1,.562,0H5.437a.563.563,0,1,1,0,1.125Z",
  transform: "translate(2.016 3)",
  fill: "#afb6c0"
}))));
export default __webpack_public_path__ + "static/media/nde.a42a05a5.svg";
export { SvgComponent as ReactComponent };